<script setup lang="ts">
import IconCoins from '~/components/Networks/Icons/IconCoins.vue'
import IconChargingBadgePass from '~/components/Networks/Icons/IconChargingBadgePass.vue'
import IconChargingStation from '~/components/Networks/Icons/IconChargingStation.vue'

defineProps({
    label: {
        type: String,
        required: true
    },
    icon: {
        type: String,
        required: true
    },
    figure: {
        type: Number,
        required: true
    }
})

const icons: { [key: string]: object } = {
    IconCoins,
    IconChargingBadgePass,
    IconChargingStation
}
</script>

<template>
    <div class="flex flex-col justify-between items-center gap-2 md:gap-4 px-2">
        <span
            class="text-center text-zinc-600 text-base font-medium font-inter leading-tight md:max-w-40"
        >
            {{ label }}
        </span>
        <div class="flex justify-center items-center gap-2">
            <component :is="icons[icon]" class="text-sky-400" />
            <span class="text-zinc-800 text-3xl font-bold font-inter">
                {{ $n(figure) }}
            </span>
        </div>
    </div>
</template>

<style lang="scss" scoped>
h3 {
    @apply text-center text-xl md:text-2xl leading-tight md:leading-loose;
}
</style>
